/* 陸遜（字伯言） */
import { along, spMul } from '../../core/kit.ts';
import type { Unit } from '../types.ts';
import { defineHero, hook, D } from '../define.ts';

export default defineHero({
  id: 'luxun', name: '陸遜', sub: '字伯言', faction: 'wu', role: '法師', weapon: 'sword',
  look: { ranged: true, dual: true, head: 'pony', fx: '#ff8a5a', c: { armor: '#c4453a' } },
  skills: [
    ['烈焰劍氣', 'bolt', '朝方向揮出一道火焰劍氣，命中第一個敵人造成 {80/130/180/230} 傷害並燃燒 2 秒（每秒 {5/10/15/20}）。', { x: { k: 'flameblade', dmg: [80, 130, 180, 230], burn: [5, 10, 15, 20] }, aim: D(650, 30), cd: 6, mp: [50, 55, 60, 65], el: 'fire' }], // v0.4.2：原「雙劍連舞」近身三連，遠程角卻要貼身
    ['火燒連營', 'trap', '在前方點燃三處營火 4 秒，每處每秒 {30/50/70/90} 傷害。', { x: { k: 'camps', dps: [30, 50, 70, 90], dur: 4, r: 70 }, aim: D(360, 70), el: 'fire' }],
    ['書生拜將', 'passive', '每施放一次技能，下一次普攻附加 {30/50/70/90} 火焰傷害。', { pv: {}, sig: 'scholar', dmg: [30, 50, 70, 90], ready: (u) => !!u.scholarB }],
    ['夷陵烈焰', 'spikes', '烈焰沿地面向前連爆六次，每次 {90/140/190} 傷害。', { pal: 'fire' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 陸遜「烈焰劍氣」：命中第一個敵人就停，點燃 2 秒
    flameblade(u, a, X) {
      const sp = spMul(u);
      this.shootProj(u, { dir: a.dir, speed: 1000, range: this.skillRange(a.sk, a.lvl), rad: 22, shape: 'fire', col: u.spec.fx, el: 'fire', big: true,
        onHit: (t: Unit) => { this.damage(u, t, X.dmg * sp, { magic: true, spell: true, stagger: 0.2, fire: true }); if (t.alive && !t.structure) this.ignite(t, X.burn, 2, u); return true; } });
    },
    // 陸遜「火燒連營」：前方三處營火
    camps(u, a, X) {
      const sp = spMul(u);
      [120, 230, 340].forEach((d) => { const p = along(u.x, u.y, a.dir, d); this.zone(u, { x: p[0], y: p[1], r: X.r, t: X.dur, tick: 0.5, dmg: X.dps * 0.5 * sp, ground: true, fire: true, pal: 'fire', name: a.sk.name }); this.fx({ k: 'fire', x: p[0], y: p[1], pal: 'fire' }); });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 書生拜將：放技能後的下一次普攻附加火焰
    hook('attack', 10, function (u, a, next) {
      const t = a.target;
      if (u.scholarB && t && t.alive && t.team !== u.team) {
        const d = u.scholarB; u.scholarB = 0;
        this.later(u.ranged ? 0.35 : 0, () => { if (t.alive) { this.damage(u, t, d * spMul(u), { magic: true, spell: true, fire: true, el: 'fire' }); this.fx({ k: 'fire', x: t.x, y: t.y, pal: 'fire', small: 1 }); } });
      }
      return next();
    }),
    hook('cast.after', 30, function (u, i, sk) { if (u.sg && u.sg.scholar) u.scholarB = u.sg.scholar.v('dmg'); }),
  ],
  // 電腦什麼時候放這招
  ai: {
    flameblade: ({ t, d, hero, u }) => !!t && d < 620 && (hero || u.mp > u.maxMp * 0.6),
    camps: ({ w, u, t, d, hero, hpR, foeHeroes }) => !!t && d < 380 && (hero || u.mp > u.maxMp * 0.6),
  },
});
